export default __webpack_public_path__ + "static/media/school8.7eb5d2ac.webp";